<script>
export let active_tab;
export let team_instance;


// alert(team_instance.has_jerseys_form);


let tabs = [
	{
		text: 'Players',
		id: 'players',
	},
	// {
	// 	text: 'Payments',
	// 	id: 'payments',
	// },
	{
		text: 'Parents',
		id: 'parents',
	},
	{
		text: 'Jerseys Form',
		id: 'jerseys_form',
	},
	{
		text: 'Tracksuits Form',
		id: 'tracksuits_form',
	},
]


function changeTab(id) {
	active_tab = id;
}

</script>



<style>


</style>



<div class="tabs is-toggle">

	<ul>

		{#each tabs as tab}

			<!-- Minis. -->
			{#if !(((tab.id === 'jerseys_form' & !team_instance.has_jerseys_form ) | (tab.id === 'tracksuits_form' & !team_instance.has_tracksuits_form ))) }

			<li class:is-active={active_tab === tab.id}>
				<a on:click={() => changeTab(tab.id)}>{tab.text}</a>
			</li>

			{/if}

		{/each}

	</ul>

</div>


